// extracted by mini-css-extract-plugin
export default {"heroContainer":"Hero_heroContainer__hScZo","heroContent":"Hero_heroContent__4CF4C"};